import Input from './src/Input';

export default Input;
